export enum NotificationChannel {
    PUSH = 'PUSH',
    EMAIL = 'EMAIL',
    SMS = 'SMS',
}

export enum NotificationType {
    GUIDE_MESSAGE = 'GUIDE_MESSAGE',
    UPCOMING_SESSION = 'UPCOMING_SESSION',
    CARD_TRANSACTION_DECLINED = 'CARD_TRANSACTION_DECLINED',
    CARD_TRANSACTION_PENDING = 'CARD_TRANSACTION_PENDING',
    CARD_TRANSACTION_POSTED = 'CARD_TRANSACTION_POSTED',
    INTEREST_POSTED = 'INTEREST_POSTED',
    CASHBACK_REWARD_POSTED = 'CASHBACK_REWARD_POSTED',
    INCOME_SPLIT_EXECUTED = 'INCOME_SPLIT_EXECUTED',
}

export interface UserNotificationChannel {
    id: string;
    userId: string;
    type: NotificationType;
    channel: NotificationChannel;
    enabled: boolean;
}
